import * as React from 'react';

import classes from './Toast.scss';
import { AlertCircleIcon } from 'components/icons';

export type ToastVariant = 'success' | 'danger';

type Props = {
  visible: boolean;
  variant?: ToastVariant;
  message: string;
  onAutoHide?: () => void;
};

const DEFAULT_AUTO_HIDE = 1000;

const Toast: React.FC<Props> = ({ visible, variant = 'success', message, onAutoHide }) => {
  React.useEffect(() => {
    if (!visible || typeof window === 'undefined') {
      return;
    }
    const timerId = window.setTimeout(() => {
      onAutoHide?.();
    }, DEFAULT_AUTO_HIDE);
    return () => window.clearTimeout(timerId);
  }, [onAutoHide, visible]);

  const shouldRenderIcon = variant === 'danger';
  const Icon = AlertCircleIcon;

  const variantClass = variant === 'danger' ? classes['toast--danger'] : classes['toast--success'];

  return (
    <div
      className={`${classes['toast']} ${variantClass} ${visible ? classes['toast--visible'] : ''}`}
      role="status"
      aria-live="polite"
      aria-hidden={!visible}
    >
      {shouldRenderIcon ? (
        <span className={classes['toast__icon']}>
          <Icon size="18px" />
        </span>
      ) : null}
      <span className={classes['toast__message']}>{message}</span>
    </div>
  );
};

export default Toast;
